export default "__VITE_ASSET__BeQMfJd0__"